const pre = '/bcos/';

export default {
    path: '/bcos/home',
    title: 'FISCO-BCOS',
    header: '',
    icon: 'md-speedometer',
}